import { usePremiumPageCopy } from '@src/pages/PremiumPage/copy';
import type { CustomAnswer, CustomField } from '@lub0v/santa-utils';
import { Input, Panel, Stack, Typography, Divider } from '@src/components';
import { CustomQuestionsForm } from '../BoxPage/full/CustomQuestions';





/** Static specimen of the real participant questionnaire controls. */
export function QuestionnaireDemo() {
  const copy = usePremiumPageCopy();
  const exampleAnswers: CustomAnswer[] = [
    { fieldId: 1, value: copy.aGoodBookWalksAndLittleSurprises },
    { fieldId: 2, value: JSON.stringify([copy.chocolate, copy.gummyCandy]) },
    { fieldId: 3, value: copy.noScentedCandlesPlease },
  ];
  const exampleFields: CustomField[] = [
    { id: 1, title: copy.whatAlwaysMakesYouHappy, type: 'string', enabled: true, required: false, visibleToSanta: true, visibleToOrganizer: true, position: 0, config: {} },
    { id: 2, title: copy.whatAreYourFavoriteSweets, type: 'multiselect', enabled: true, required: false, visibleToSanta: true, visibleToOrganizer: true, position: 1, config: { options: [copy.chocolate, copy.gummyCandy, copy.cookies] } },
    { id: 3, title: copy.whatWouldYouPreferNotToReceive, type: 'string', enabled: true, required: false, visibleToSanta: true, visibleToOrganizer: true, position: 2, config: {} },
  ];
  return <div className="premium-question-example" data-testid="premium-question-example">
    <header><Typography as="h3" role="title/sub">{copy.fillOutYourQuestionnaire}</Typography><Typography as="p" role="meta/helper">{copy.aLittleAboutYouForThoughtfulGifts}</Typography></header>
    <Panel bordered padding="medium" wide>
      <Stack gap={4}>
        <fieldset className="custom-question"><legend>{copy.yourNameOrNickname}</legend><Typography as="p" role="meta/helper">{copy.visibleToEveryoneInTheGame}</Typography><Input value={copy.olivia} onValueChange={() => {}} readOnly aria-label={copy.participantNameInTheExample} /></fieldset>
        <Divider />
        <div inert><CustomQuestionsForm fields={exampleFields} answers={exampleAnswers} onChange={() => {}} showHeading={false} testIdPrefix="premium-example" /></div>
      </Stack>
    </Panel>
    <Typography as="p" role="meta/helper">{copy.exampleParticipantQuestionnaire}</Typography>
  </div>;
}
